import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M12.0023 15.3333C21.2498 15.3333 21.1582 21.0583 21.1582 21.0583C21.2282 21.5783 20.8532 22 20.3198 22H3.68484C3.15151 22 2.75568 21.5725 2.84651 21.0583C2.84651 21.0583 2.75318 15.3333 12.0023 15.3333ZM11.9998 2H17.8332V7.83333C17.8332 8.98706 17.4911 10.1149 16.8501 11.0742C16.2091 12.0334 15.2981 12.7811 14.2322 13.2226C13.1663 13.6641 11.9934 13.7797 10.8618 13.5546C9.73026 13.3295 8.69086 12.7739 7.87505 11.9581C7.05925 11.1423 6.50368 10.1029 6.2786 8.97136C6.05352 7.8398 6.16903 6.66692 6.61055 5.60101C7.05206 4.53511 7.79973 3.62407 8.75902 2.98309C9.7183 2.34212 10.8461 2 11.9998 2Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }